import type { Prototype } from "../prototype-types";

export const michaelYenPrototypes: Prototype[] = [
  {
    id: "vibe-swipe",
    name: "Vibe Swipe",
    path: "/my/vibe-swipe",
    description:
      "Tinder-style brand discovery for retailers. Swipe through brand social content to build a personalized vibe profile.",
    owner: "Michael",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/41d85facadafa267d12a1d2e0402179d74cdd3288013930be7c9574f1192a953.png",
  },
];
